<template>
  <div>
    <!-- Modal: 獎牌兌換成點數 -->
    <div class="modal fade" id="modal-award--medals">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">獎牌兌換成點數</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span
                aria-hidden="true">&times;</span> </button>
          </div>
          <div class="modal-body">
            <div class="form-group mb-3">
              <label>獎牌</label>
              <div class="input-group">
                <input type="text" class="form-control" placeholder="" v-model="medalData.medalTitle" disabled>
              </div>
            </div>
            <div class="form-group mb-3">
                <label>點數-操作前</label>
                <div class="input-group">
                  <input type="text" class="form-control" placeholder="" v-model="medalData.sgL_BeforePoint" disabled>
                </div>
              </div>
            <div class="form-group">
              <label>點數-操作後</label>
              <div class="input-group">
                <input type="text" class="form-control" placeholder="" v-model="medalData.sgL_AfterPoint" disabled>
              </div>
            </div>

            <!-- <div class="form-group mb-3">
              <label>兌換點數(將得到的獎牌轉換成預設點數)轉換後無法回復</label>
              <div class="input-group">
                <select class="form-control custom-select select2-no-search" v-model="medalData.sgL_BeforePoint">
                  <option>兌換</option>
                  <option selected>不用了</option>
                </select>
              </div>
            </div> -->
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
            <button type="button" class="btn btn-primary"  @click="MedalSubmit">兌換</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.Modal: 修改用戶點數資料 -->
  </div>
</template>
<script>
export default {
  name: 'medalView',
  data () {
    return {
      medalData: {},
    };
  },
  //DOM加載前
  created () {
  },
  //DOM加載后
  mounted () {
  },
  //方法
  methods: {
    hideWindow () {
      $("#modal-award--medals").modal("hide");
      this.$emit("hide");
    },
    showWindow () {
      $("#modal-award--medals").modal("show");
      this.$emit("show");
    },
    async setData (Id) {
      const { data } = await this.$api.social.MedalInfo({ 'id': Id });
      if (!data.success) {
        this.$message.warning(data.error.message);
        return;
      }
      this.medalData = data.result;
      this.showWindow();
    },
    async MedalSubmit(){
        this.$confirm('確認兌換點數(將得到的獎牌轉換成預設點數)轉換後無法回復。', '提示', {
        confirmButtonText: '是，兌換',
        cancelButtonText: '取消',
        type: 'success',
      }).then(async () => {
         const { data } = await this.$api.social.MedalSubmit({ 'id': this.medalData.medalId });
        if (!data.success) {
          this.$message.warning(data.error.message);
          return;
        }
        this.$message.success("操作成功");
        this.hideWindow();
        this.$emit("onMedalSubmit", true);
      }).catch(() => { });
    },
    clearData () {
      this.medalData = {};
    }
  },
  beforeDestroy () {
    this.clearData();
  },
  //观察器
  watch: {
  },
  //计算属性
  computed: {
  },
  //組件
  components: {
  },
}
</script>
<style scoped>
.modal .btn {
  margin-left: 0px !important;
}
 .modal .btn:hover {
    background-color: #26AD5E;
    color: #ffffff;
    border-color: #26AD5E;
} 
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/Social/medalView.vue